const {GET_STATES_REQ} = require("./statesTypes");


const initialState = {
    statesList: []
}

const statesReducer = (state = initialState, action) => {

    if (action.type === GET_STATES_REQ) {
        return {
            ...state,
            statesList: action.payload.data
        }
    } else {
        return state;
    }
}

export default statesReducer
